export const TRACKED_STANDARD_EVENT_ACTIONS = {
  goToShoppingBasket: 'Go To Shopping Basket',
  continuePurchasing: 'Continue Purchasing',
  onlineToolsOpen: 'Online Tools | Open',
  tabSelect: 'Tab | Select',
  articleSort: 'Article | Sort',
} as const;

export type StandardAction = (typeof TRACKED_STANDARD_EVENT_ACTIONS)[keyof typeof TRACKED_STANDARD_EVENT_ACTIONS];
